import React, {useState} from "react";
import CenterLogoheader from "../../components/MainHeader/CenterLogoheader";
import {Link, useNavigate} from "react-router";
import Nopreview from "../../assets/images/Nopreview.svg";
import Preview from "../../assets/images/preview.svg";
import ExclamationIcon from "../../assets/images/exclamation.svg";
import {useUserContext} from "../../context/UserContext";
import {doctorLoginApi, nurseLoginApi} from "../../services/apiService";
import {toast} from "react-toastify";
import Cookies from "js-cookie";

const NurseLogin = () => {
  const {setUserData, isActiveDocAcc, setIsActiveDocAcc, setCookiesValue} = useUserContext();
  const navigate = useNavigate();

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formDataSignin, setFormDataSignin] = useState({
    email: "",
    password: "",
  });

  const [formErrorsSignin, setFormErrorsSignin] = useState({
    email: "",
    password: "",
  });

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleChangeSignin = e => {
    const {name, value} = e.target;
    setFormDataSignin({...formDataSignin, [name]: value});
    setFormErrorsSignin({...formErrorsSignin, [name]: ""});
  };

  const submitLogin = e => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  const handleLogin = async () => {
    try {
      if (validateFormSignin()) {
        setIsSubmitting(true);
        let apiRes = await nurseLoginApi(formDataSignin);
        let responseData = apiRes;

        if (responseData.data.res == false) {
          //setErrorMessage(responseData.data.msg)
          toast.error(responseData.data.msg, {autoClose: 1500});
        } else {
          localStorage.setItem("doctolikLoginInfo", JSON.stringify(responseData.data.data));
          setUserData(responseData.data.data);

          Cookies.set("doctolikAuthToken", responseData.data?.data?.authorisation?.token, {
            expires: 7,
            secure: true, // Ensures the cookie is only sent over HTTPS
            sameSite: "Strict",
          });
          setCookiesValue(responseData.data?.data?.authorisation?.token);

          toast.success(responseData.data.msg ? responseData.data.msg : "Logged in successfully", {autoClose: 1500});
          navigate("/nurse/appointments");
        }
        setIsSubmitting(false);
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {autoClose: 1500});
    }
  };

  const validateFormSignin = () => {
    let isValid = true;
    const errors = {
      email: "",
      password: "",
    };

    if (formDataSignin.email === "") {
      errors.email = "Please enter your email";
      isValid = false;
    }

    if (formDataSignin.password === "") {
      errors.password = "Please enter your password";
      isValid = false;
    }

    setFormErrorsSignin(errors);
    return isValid;
  };

  return (
    <div className="Main">
      <CenterLogoheader />
      <div className="Fullbody">
        <div className="LoginBox">
          <h3>Login</h3>
          <h4>Welcome Back! </h4>

          <div className="input-group">
            <input
              type="email"
              placeholder="Email address"
              className={`emailInput ${formErrorsSignin.email ? "inputHaveError" : ""}`}
              name="email"
              value={formDataSignin.email}
              onChange={handleChangeSignin}
              onKeyDown={submitLogin}
            />
            {formErrorsSignin.email && (
              <span className="vaidationError">
                <img className="exclamationIcon" src={ExclamationIcon} /> {formErrorsSignin.email}
              </span>
            )}
          </div>

          <div className="input-group">
            <input
              name="password"
              value={formDataSignin.password}
              onChange={handleChangeSignin}
              onKeyDown={submitLogin}
              type={passwordVisible ? "text" : "password"}
              placeholder="Password"
              className={`passwordInput ${formErrorsSignin.password ? "inputHaveError" : ""}`}
            />
            <span className="password-icon" onClick={togglePasswordVisibility}>
              <img src={passwordVisible ? Nopreview : Preview} alt="Toggle Password Visibility" />
            </span>
            {formErrorsSignin.password && (
              <span className="vaidationError">
                <img className="exclamationIcon" src={ExclamationIcon} />
                {formErrorsSignin.password}
              </span>
            )}
          </div>

          <Link to="/forgot-password" className="forgot-password">
            Forgot Password
          </Link>
          <button type="submit" className="login-button" onClick={() => handleLogin()} disabled={isSubmitting}>
            {isSubmitting ? "Please wait..." : "Login"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NurseLogin;
